// extracted by mini-css-extract-plugin
export default {"selectBox":"select_selectBox__DafUq","solid":"select_solid__ALIKF","outline":"select_outline__vcxyF","arrow":"select_arrow__J5rfG"};